import { regexUrl } from 'Helpers/regexHelpers'
import {
  Button,
  BUTTON_VARIANT_NEUTRAL,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem,
  FormElement,
  InputText,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  RadioButtonsGroup,
  SPACING_16,
  SpacingVertical,
  Text
} from 'mailup-web-components'
import { addSourceCallback } from 'Pages/Campaign/recoil/callbacks/callbacks'
import { modalNewSourceState } from 'Pages/Campaign/recoil/state/modals'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'

const ModalNewSource = () => {
  const intl = useIntl()
  const history = useHistory()

  const {
    show,
    sourceType,
    sourceName,
    sourceUrl,
    sourceNameIsDirty,
    sourceUrlIsDirty,
    sourceUrlInvalid
  } = useRecoilValue(modalNewSourceState)
  const resetModal = useResetRecoilState(modalNewSourceState)
  const setModalNewSourceState = useSetRecoilState(modalNewSourceState)
  const addSource = useRecoilCallback(addSourceCallback, [])

  const sourceTypeOptions = [
    {
      label: intl.formatMessage({
        id: 'Load.ContentsSouces.NewUrlTitle'
      }),
      value: 'feed',
      'data-mu-test': 'NewUrl'
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentsSouces.NewFileTitle'
      }),
      value: 'file',
      'data-mu-test': 'NewFile'
    }
  ]

  const onChangeSourceType = (val) => {
    setModalNewSourceState((prev) => ({
      ...prev,
      sourceType: val
    }))
  }

  const onChangeName = (e) => {
    setModalNewSourceState((prev) => ({
      ...prev,
      sourceName: e.target.value,
      sourceNameIsDirty: true
    }))
  }

  const onChangeUrl = (e) => {
    setModalNewSourceState((prev) => ({
      ...prev,
      sourceUrl: e.target.value,
      sourceUrlIsDirty: true,
      sourceUrlInvalid: !regexUrl.test(e.target.value)
    }))
  }

  const saveSource = () => {
    addSource()
  }

  const goToNewFeedSource = () => {
    history.push(`/automation/source/1/0?name=${sourceName}&url=${sourceUrl}`)
  }

  const goToNewFileSource = () => {
    history.push(`/automation/source/2/0`)
  }

  return (
    <Modal show={show} closeOnOverlayClick onClose={resetModal}>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ContentsSouces.NewSourceModalTitle'
        })}
      />
      <ModalBody>
        <Flex width='100%' justifyContent='center' alignItems='center'>
          <RadioButtonsGroup
            items={sourceTypeOptions}
            onChange={onChangeSourceType}
            value={sourceType}
          />
        </Flex>
        <SpacingVertical />
        {sourceType === 'feed' && (
          <>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentsSouces.NewSource'
              })}
              required
              feedback={
                !sourceName && sourceNameIsDirty
                  ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                  : null
              }
            >
              <InputText
                placeholder={intl.formatMessage({
                  id: 'Load.ContentsCampaignWizard.NewSourcePlaceholder'
                })}
                onChange={onChangeName}
                value={sourceName}
                data-mu-test='input-name'
                maxLength='128'
                variant={!sourceName && sourceNameIsDirty ? 'danger' : ''}
              />
            </FormElement>
            <SpacingVertical varian={SPACING_16} />
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentsSouces.UrlFeed'
              })}
              required
              feedback={
                (!sourceUrl && sourceUrlIsDirty) || sourceUrlInvalid
                  ? intl.formatMessage({ id: 'Load.Common.InvalidUrl' })
                  : null
              }
            >
              <InputText
                placeholder={intl.formatMessage({
                  id: 'Load.Common.UrlPlaceholder'
                })}
                onChange={onChangeUrl}
                value={sourceUrl}
                data-mu-test='input-url'
                maxLength='1024'
                variant={
                  (!sourceUrl && sourceUrlIsDirty) || sourceUrlInvalid
                    ? 'danger'
                    : ''
                }
              />
            </FormElement>
          </>
        )}
        {sourceType === 'file' && (
          <Text>
            {intl.formatMessage({
              id: 'Load.ContentsCampaignWizard.NewSourceFileDescr'
            })}
          </Text>
        )}
      </ModalBody>

      <ModalFoot>
        {sourceType === 'feed' && (
          <Flex width='100%' justifyContent='space-between'>
            <FlexItem margin='0 0 0 -10px'>
              <Button kind={BUTTON_VARIANT_NEUTRAL} onClick={goToNewFeedSource}>
                {intl.formatMessage({
                  id: 'Load.MailupCommon.AdvancedOptions'
                })}
              </Button>
            </FlexItem>
            <FlexItem>
              <Button kind={BUTTON_VARIANT_SECONDARY} onClick={resetModal}>
                {intl.formatMessage({
                  id: 'Load.MailupCommon.Cancel'
                })}
              </Button>
              <Button
                kind={BUTTON_VARIANT_PRIMARY}
                onClick={saveSource}
                disabled={!sourceName || !sourceUrl || sourceUrlInvalid}
              >
                {intl.formatMessage({
                  id: 'Load.MailupCommon.Save'
                })}
              </Button>
            </FlexItem>
          </Flex>
        )}
        {sourceType === 'file' && (
          <>
            <Button kind={BUTTON_VARIANT_SECONDARY} onClick={resetModal}>
              {intl.formatMessage({
                id: 'Load.MailupCommon.Cancel'
              })}
            </Button>
            <Button kind={BUTTON_VARIANT_PRIMARY} onClick={goToNewFileSource}>
              {intl.formatMessage({
                id: 'Load.Common.GoToPage'
              })}
            </Button>
          </>
        )}
      </ModalFoot>
    </Modal>
  )
}

export default ModalNewSource
